const Footer = () => {
  return (
    <footer className="footer">
      <p>Questions? Call 1-866-579-7172</p>
      <div className="foot-cols">
        <ul>
          <li>FAQ</li>
          <li>Investor Relations</li>
          <li>Ways To Watch</li>
          <li>Corporate Information</li>
          <li>Netflix Originals</li>
        </ul>
        <ul>
          <li>Help Center</li>
          <li>Jobs</li>
          <li>Terms Of Use</li>
          <li>Contact Us</li>
        </ul>
        <ul>
          <li>Account</li>
          <li>Redeem Gift Cards</li>
          <li>Privacy</li>
          <li>Speed Tes</li>
        </ul>
        <ul>
          <li>Media Center</li>
          <li>Buy Gift Cards</li>
          <li>Cookie Preferences</li>
          <li>Legal Notices</li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
